(function ($){
    const $toggleSearch = $('#toggle-search')
    const $searchContainer = $('.header__search')

    $toggleSearch.on('click', function (e){
        e.preventDefault()

        $searchContainer.toggleClass('_show')
    })
})(jQuery)
